var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 7.93783C4.82891 7.93783 3.41797 6.43283 3.41797 4.58366C3.41797 2.73449 4.82891 1.22949 6.5625 1.22949C8.29609 1.22949 9.70703 2.73449 9.70703 4.58366C9.70703 6.43283 8.29609 7.93783 6.5625 7.93783ZM6.5625 2.10449C5.28281 2.10449 4.23828 3.21866 4.23828 4.58366C4.23828 5.94866 5.28281 7.06283 6.5625 7.06283C7.84219 7.06283 8.88672 5.94866 8.88672 4.58366C8.88672 3.21866 7.84219 2.10449 6.5625 2.10449Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2602 13.7708C11.036 13.7708 10.8501 13.5725 10.8501 13.3333C10.8501 11.3208 8.92508 9.6875 6.56258 9.6875C4.20008 9.6875 2.27509 11.3208 2.27509 13.3333C2.27509 13.5725 2.08915 13.7708 1.86493 13.7708C1.64071 13.7708 1.45477 13.5725 1.45477 13.3333C1.45477 10.8425 3.74618 8.8125 6.56258 8.8125C9.37899 8.8125 11.6704 10.8425 11.6704 13.3333C11.6704 13.5725 11.4845 13.7708 11.2602 13.7708Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.21fbf6280b6d0f69e22935fc16eaa89f.svg";
export { ForwardRef as ReactComponent };